import { Bolt as BoltIcon } from "@mui/icons-material";
import { Box, MenuItem, Select, SelectChangeEvent, Button } from "@mui/material";
import { Typography, Tooltip } from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";

import { useBusinessContext } from "0.Mine/2.Context/businessContext";

import LanguageSelector from "./Profile/LanguageSwitcher";

interface AICreditsCounterProps {
  credits: number;
}

export const AICreditsCounter: React.FC<AICreditsCounterProps> = ({ credits }) => {
  return (
    <Tooltip title="Crediti AI Residui" arrow>
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#f5f5f5",
          borderRadius: "16px",
          padding: "4px 8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          cursor: "default",
        }}
      >
        <BoltIcon sx={{ color: "#ff9800", fontSize: 20, marginRight: "4px" }} />
        <Typography variant="body2" sx={{ fontWeight: 500, color: "#333" }}>
          {credits}
        </Typography>
      </Box>
    </Tooltip>
  );
};
const RightActionBar: React.FC = () => {
  const { session, selectBusiness } = useBusinessContext();
  const businesses = session?.businesses || [];
  const selectedBusinessId = session?.selectedBusiness?.id?.toString() || "";

  const handleDropdownChange = (event: SelectChangeEvent) => {
    const newBusinessId = event.target.value;
    if (!newBusinessId) return;

    localStorage.removeItem("customFields");
    localStorage.removeItem("business_session_validated");

    selectBusiness(newBusinessId);
    localStorage.setItem("selectedBusiness", newBusinessId);
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} width="100%">
      {/*<AICreditsCounter credits={1000} />*/}
      <Select
        value={selectedBusinessId}
        onChange={handleDropdownChange}
        size="small"
        displayEmpty
        sx={{ minWidth: 200, borderRadius: "999px" }}
      >
        <MenuItem value="" disabled>
          Select a business
        </MenuItem>
        {businesses.length > 0 ? (
          businesses.map((business) => (
            <MenuItem key={business.id} value={business.id}>
              {business.name}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No businesses available</MenuItem>
        )}
      </Select>

      <LanguageSelector />
    </Box>
  );
};

export default RightActionBar;
